import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getSearch } from 'api/Search';
import { fetchWithLanguage } from 'store/helpers';

export const fetchSearch = fetchWithLanguage('fetchSearch', getSearch);

const searchSlice = createSlice({
    name: 'searchSlice',
    initialState: {
        searchData: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchSearch.fulfilled, (state, action) => {
            state.searchData = action.payload;
        });
    },
});

export const selectSearchData = createSelector(
    [state => state.searchState.searchData],
    searchData => searchData.data || {},
);

export default searchSlice.reducer;
